export const architectureSources = [
    { value: 'Fremium', name: 'Fremium' },
    { value: 'Premium', name: 'Premium' },
    { value: 'Demo', name: 'Demo' },
    { value: 'Order', name: 'Order' },
];

export const sharingStatisticsInfo = [
    {
        month: "January",
        Fremium: 33,
        Premium: 3,
        Demo: 15,
        Order: 10,
    },{
        month: "Fabruary",
        Fremium: 63,
        Premium: 5,
        Demo: 45,
        Order: 45,
    },{
        month: "March",
        Fremium: 120,
        Premium: 14,
        Demo: 80,
        Order: 98,
    },{
        month: "April",
        Fremium: 255,
        Premium: 16,
        Demo: 136,
        Order: 98,
    },{
        month: "June",
        Fremium: 315,
        Premium: 60,
        Demo: 240,
        Order: 170,
    },{
        month: "July",
        Fremium: 521,
        Premium: 100,
        Demo: 345,
        Order: 80,
    },
];

export const seriesTypeLabel = { 'aria-label': 'Series Type' };